/* eslint-disable react/prop-types */
import React from 'react';
import { Navigate } from 'react-router-dom';

export const PublicAdminRoute = ({ children }) => {
  const logueado = false;
  return !logueado ? children : <Navigate to="/" />;
};
